var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-section layout__grow"},[_c('div',{staticClass:"ui-section__header"},[_vm._t("header")],2),_c('div',{staticClass:"ui-section__content layout__grow"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }